import { render, staticRenderFns } from "./VerificationList.vue?vue&type=template&id=005699b2&scoped=true"
import script from "./VerificationList.vue?vue&type=script&lang=js"
export * from "./VerificationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005699b2",
  null
  
)

export default component.exports